export interface HeroMetric {
  label: string;
  value: string;
  isPositive: boolean;
}

export const heroMetrics: HeroMetric[] = [
  { label: "Δ NAV", value: "+0.0038", isPositive: true },
  { label: "Δ EXPOSURE", value: "-1.08%", isPositive: false },
  { label: "MODEL STATUS", value: "ACTIVE", isPositive: true },
  { label: "VAR CHECK", value: "PASS", isPositive: true },
  { label: "SIM ENGINE", value: "ONLINE", isPositive: true },
  { label: "RISK POLICY", value: "LOADED", isPositive: true },
];

